import { render, staticRenderFns } from "./StudentView.vue?vue&type=template&id=564c73e4&scoped=true"
import script from "./StudentView.vue?vue&type=script&lang=js"
export * from "./StudentView.vue?vue&type=script&lang=js"
import style0 from "./StudentView.vue?vue&type=style&index=0&id=564c73e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564c73e4",
  null
  
)

export default component.exports